import Switcher from 'frontend/components/reports/switcher';
<template>
  <Switcher />
  {{outlet}}
</template>
